var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.266,
    height: 44.825,
    viewBox: "0 0 46.266 44.825",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1",
    transform: "translate(-24.935)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_28",
    "data-name": "Grupo 28",
    transform: "translate(24.935)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_23",
    "data-name": "Grupo 23",
    transform: "translate(0 11.874)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_266",
    "data-name": "Trazado 266",
    d: "M111.31,207.055c4.65-.991,9.422.255,13.913,1.481a52.063,52.063,0,0,1,13.442,5.622,26.756,26.756,0,0,1,9.988,10.409,39.669,39.669,0,0,1-20.542-4.818,56,56,0,0,1-16.8-12.693Z",
    transform: "translate(-107.834 -196.389)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_267",
    "data-name": "Trazado 267",
    d: "M119.711,191.507a1.988,1.988,0,0,1-.275.742,10.039,10.039,0,0,0,1.193.064,4.037,4.037,0,0,0,1.966-.767,1.862,1.862,0,0,0,.8-1.564,3.3,3.3,0,0,0-.845-1.534,2.012,2.012,0,0,1,1.545,3.5,5.529,5.529,0,0,1-5.065,1.336.925.925,0,0,0-.822.152c-5.319,3.622-12.454,2.9-18.251.893A35.4,35.4,0,0,1,88.6,188.078c-3.043-2.586-6.631-6.8-6.67-11.041a.562.562,0,0,0-.245-.4,6.032,6.032,0,0,1-2.753-4.782,3.073,3.073,0,0,1,.249-1.589,1.916,1.916,0,0,1,3.241-.057c-.586.042-1.287-.408-1.874.072a1.649,1.649,0,0,0-.465,1.264,5.669,5.669,0,0,0,1.307,3.725,1.629,1.629,0,0,0,.437.282c.053-.152.105-.3.157-.458a4.1,4.1,0,0,1,.173-.5.306.306,0,0,1,.221-.136c.046,0,.124.1.152.164.887,2.182,2.873,3.8,4.646,5.253,5.616,4.61,12.472,7.779,19.34,10.022a39.69,39.69,0,0,0,6.635,1.591,29.91,29.91,0,0,0,3.489.3c1.079.029,2.042-.289,3.072-.3v.01Z",
    transform: "translate(-78.919 -163.048)",
    fill: "#e83f3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_268",
    "data-name": "Trazado 268",
    d: "M168.866,117.568a9.738,9.738,0,0,1,1.063.5,4.449,4.449,0,0,1,2.093,3.871,5.745,5.745,0,0,1-1.167,3.674.412.412,0,0,1-.082.1c-.109.076-.223.144-.336.216a1.554,1.554,0,0,1-.1-.353,4.567,4.567,0,0,0-1.188-2.763c-.37-.435-.812-.807-1.19-1.234a12.577,12.577,0,0,1-1.119-1.4,1.8,1.8,0,0,1-.217-1.642,1.512,1.512,0,0,1,1.62-1.04c.087.005.174,0,.261,0l.364.068Z",
    transform: "translate(-157.111 -116.765)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_269",
    "data-name": "Trazado 269",
    d: "M434.7,280.805a3.275,3.275,0,0,1,1.388,1.684,1.512,1.512,0,0,1-.1,1.266.962.962,0,0,1-.854.463,2.79,2.79,0,0,1-1.255-.317c-1.029-.44-2.043-.92-3.089-1.317a5.188,5.188,0,0,0-2.564-.37,4.951,4.951,0,0,0-.691.209,1.562,1.562,0,0,1-.236.032.981.981,0,0,1,.087-.236,4.4,4.4,0,0,1,1.576-1.289,5.986,5.986,0,0,1,5.017-.444c.279.1.543.24.719.32Z",
    transform: "translate(-389.913 -261.942)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_270",
    "data-name": "Trazado 270",
    d: "M172.912,175.08a.644.644,0,0,0-.294.072.364.364,0,0,1,.019.119.376.376,0,0,1-.371.375.7.7,0,0,0-.006.084.657.657,0,1,0,.652-.649Z",
    transform: "translate(-162.243 -168.165)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_271",
    "data-name": "Trazado 271",
    d: "M497.308,272.351a.452.452,0,0,0-.126-.165.279.279,0,0,1-.07.045.256.256,0,0,1-.336-.131.445.445,0,0,0-.054.018.451.451,0,1,0,.586.233Z",
    transform: "translate(-451.643 -254.774)",
    fill: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_272",
    "data-name": "Trazado 272",
    d: "M436.473,252.35a1.393,1.393,0,0,1,1.023.365.993.993,0,0,1,.318.665.626.626,0,0,1-.207.523,1.177,1.177,0,0,1-.585.271c-.531.133-1.067.24-1.593.4a2.328,2.328,0,0,0-1.118.692,3.067,3.067,0,0,0-.215.341.815.815,0,0,1-.084.1.736.736,0,0,1-.032-.147,3.153,3.153,0,0,1,.26-1.183,3.091,3.091,0,0,1,1.858-1.938,3.588,3.588,0,0,1,.375-.087Z",
    transform: "translate(-395.876 -237.143)",
    fill: "#f49a37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_273",
    "data-name": "Trazado 273",
    d: "M218.831,110.688a2.7,2.7,0,0,1,.334.243,2.1,2.1,0,0,1,.461,1.823,3.732,3.732,0,0,1-.651,1.707.235.235,0,0,1-.035.047c-.043.034-.087.065-.131.1a.853.853,0,0,1-.012-.165,2.366,2.366,0,0,0-.223-1.3c-.1-.206-.226-.383-.328-.586a5.177,5.177,0,0,1-.292-.661,1.083,1.083,0,0,1,.036-.768c.138-.335.368-.5.631-.473a.842.842,0,0,0,.09,0l.121.034Z",
    transform: "translate(-202.984 -110.65)",
    fill: "#f49a37"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_274",
    "data-name": "Trazado 274",
    d: "M145.913,217.04l-.115-.119a3.2,3.2,0,0,1-.676-.913.742.742,0,0,1-.07-.449c.079-.357.511-.482.868-.516a17.848,17.848,0,0,1,10.032,2.344c5.212,3.061,11.051,4.739,16.258,7.747a6.263,6.263,0,0,1,3.008,3.022,1.691,1.691,0,0,1,.089,1.037,1.437,1.437,0,0,1-1.126.92c-1.94.393-4.476-.226-6.367-.685a46.152,46.152,0,0,1-6.294-2.1,46.827,46.827,0,0,1-10.945-6.219,41.9,41.9,0,0,1-4.664-4.073Z",
    transform: "translate(-137.945 -191.915)",
    fill: "#f49936"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_139",
    "data-name": "Rect\\xE1ngulo 139",
    width: 11.194,
    height: 3.844,
    rx: 1.922,
    transform: "translate(30.236)",
    fill: "#fabd01"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_275",
    "data-name": "Trazado 275",
    d: "M361.2,0h10.138a.528.528,0,0,1,.528.528v.778H360.67V.528A.528.528,0,0,1,361.2,0Z",
    transform: "translate(-330.434)",
    fill: "#ae191b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_276",
    "data-name": "Trazado 276",
    d: "M.528,0H10.666a.528.528,0,0,1,.528.528v.778H0V.528A.528.528,0,0,1,.528,0Z",
    transform: "translate(41.43 3.844) rotate(180)",
    fill: "#ae191b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_140",
    "data-name": "Rect\\xE1ngulo 140",
    width: 11.194,
    height: 3.844,
    rx: 1.922,
    transform: "translate(17.511)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_277",
    "data-name": "Trazado 277",
    d: "M148.8,215.594a1.762,1.762,0,0,0-1.126-.529,5.632,5.632,0,0,0-1.725-.005.973.973,0,0,0-.725.367.814.814,0,0,0-.067.555,3.014,3.014,0,0,0,.624,1.256,21.855,21.855,0,0,0,5.6,4.816,68.747,68.747,0,0,0,11.3,5.722,44.187,44.187,0,0,0,7.467,2.629c1.463.321,4.591.868,5.246-1.039a.719.719,0,0,0-.181-.783.879.879,0,0,0-.646-.139,9.572,9.572,0,0,1-2.153.091,51.466,51.466,0,0,1-16.142-4.841,18.671,18.671,0,0,1-4.414-2.757,8.351,8.351,0,0,1-2.716-4.358,2.4,2.4,0,0,0-.326-.955l-.023-.029Z",
    transform: "translate(-138.028 -191.924)",
    fill: "#ef8f2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_278",
    "data-name": "Trazado 278",
    d: "M242.618,0h10.138a.528.528,0,0,1,.528.528v.778H242.09V.528A.528.528,0,0,1,242.618,0Z",
    transform: "translate(-224.579)",
    fill: "#74acdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_279",
    "data-name": "Trazado 279",
    d: "M.528,0H10.666a.528.528,0,0,1,.528.528v.778H0V.528A.528.528,0,0,1,.528,0Z",
    transform: "translate(28.705 3.844) rotate(180)",
    fill: "#74acdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_280",
    "data-name": "Trazado 280",
    d: "M264.859,45.65H243.24a1.15,1.15,0,0,0-1.15,1.15V61.925A10.274,10.274,0,0,0,252.364,72.2h1.849a11.8,11.8,0,0,0,11.8-11.8V46.8a1.15,1.15,0,0,0-1.15-1.15ZM251.542,67.6h0a4.6,4.6,0,0,1-4.6-4.6V60.849h4.6Zm0-11.015h-4.6V51.231h4.6Zm9.782,6.411a4.6,4.6,0,0,1-4.6,4.6h0V60.848h4.6Zm0-6.411h-4.6V51.231h4.6Z",
    transform: "translate(-224.579 -40.751)",
    fill: "#e83f3f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_24",
    "data-name": "Grupo 24",
    transform: "translate(12.547 25.851)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_281",
    "data-name": "Trazado 281",
    d: "M324.657,305.8a1.012,1.012,0,0,0,.512.142c.07-.012.141-.085.1-.161a.6.6,0,0,0-.563-.269.153.153,0,0,0-.054.289h0Z",
    transform: "translate(-310.758 -298.575)",
    fill: "#f8b067"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_282",
    "data-name": "Trazado 282",
    d: "M330.675,312.7c.086.106.224.25.376.192a.113.113,0,0,0,.069-.143c-.057-.123-.194-.15-.306-.209-.093-.049-.207.075-.138.161h0Z",
    transform: "translate(-316.186 -304.838)",
    fill: "#f8b067"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_283",
    "data-name": "Trazado 283",
    d: "M333.379,319.378c.058.139.219.343.39.23a.163.163,0,0,0,.056-.2c-.024-.067-.1-.094-.121-.148a.178.178,0,0,0-.22-.105.174.174,0,0,0-.105.22h0Z",
    transform: "translate(-318.607 -310.749)",
    fill: "#f8b067"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_284",
    "data-name": "Trazado 284",
    d: "M340.97,325.3a.371.371,0,0,0,.21.159.2.2,0,0,0,.23-.1.109.109,0,0,0-.026-.127c.015.016-.054-.058-.031-.038a.256.256,0,0,0-.1-.043.176.176,0,0,1-.076-.038.142.142,0,0,0-.21.187h0Z",
    transform: "translate(-325.374 -316.044)",
    fill: "#f8b067"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_285",
    "data-name": "Trazado 285",
    d: "M338.363,316.077c.1.107.3.223.417.088a.115.115,0,0,0,.009-.134c-.05-.1-.176-.09-.256-.147a.128.128,0,0,0-.168.193h0Z",
    transform: "translate(-323.034 -307.81)",
    fill: "#f8b067"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_286",
    "data-name": "Trazado 286",
    d: "M337.283,312.15c.085.011.166.065.251.029a.131.131,0,0,0,.086-.133c-.027-.138-.156-.182-.283-.2-.2-.026-.251.277-.055.3h0Z",
    transform: "translate(-321.993 -304.231)",
    fill: "#f8b067"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_287",
    "data-name": "Trazado 287",
    d: "M356.6,309.642c.19,0,.236.176.38.234a.833.833,0,0,1,.279.159c.07.063.106.144.206.153a.075.075,0,0,0,.076-.039c.074-.119-.033-.244-.132-.312a.411.411,0,0,0-.2-.073c-.089-.006-.157.042-.244.044l.029.058c.166-.246-.235-.4-.422-.349-.073.02-.043.126.027.124h0Z",
    transform: "translate(-339.282 -302.144)",
    fill: "#f8b067"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_288",
    "data-name": "Trazado 288",
    d: "M366.378,322.577a1.775,1.775,0,0,1,.419.209.158.158,0,0,0,.172-.261.644.644,0,0,0-.582-.126.09.09,0,0,0-.009.177Z",
    transform: "translate(-348.012 -313.638)",
    fill: "#f8b067"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_289",
    "data-name": "Trazado 289",
    d: "M353.013,301.15a.884.884,0,0,0,.26.161.139.139,0,0,0,.143-.062.147.147,0,0,0,0-.158.307.307,0,0,0-.37-.115.1.1,0,0,0-.033.173h0Z",
    transform: "translate(-336.113 -294.51)",
    fill: "#f8b067"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_290",
    "data-name": "Trazado 290",
    d: "M300.113,317.746c.181,0,.182.12.285.214a.321.321,0,0,0,.228.067.685.685,0,0,1,.349.085.261.261,0,0,0,.234.044.1.1,0,0,0,.068-.079c.072-.291-.355-.352-.549-.329-.083.01-.128.028-.191-.026-.048-.041-.069-.084-.125-.118a.394.394,0,0,0-.335-.031c-.1.03-.061.176.036.174h0Z",
    transform: "translate(-288.837 -309.322)",
    fill: "#f8b067"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_291",
    "data-name": "Trazado 291",
    d: "M319.642,324.732c.065-.02.122.017.182.035.162.05.255-.19.138-.29a.406.406,0,0,0-.457-.016.15.15,0,0,0-.049.193.152.152,0,0,0,.185.075h0Z",
    transform: "translate(-306.176 -315.437)",
    fill: "#f8b067"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_292",
    "data-name": "Trazado 292",
    d: "M293.909,299.3a.447.447,0,0,1,.192.018c.061.025.1.086.176.1a.169.169,0,0,0,.191-.132c.041-.153-.117-.267-.247-.3a.619.619,0,0,0-.366.063.131.131,0,0,0,.054.252h0Z",
    transform: "translate(-283.261 -292.743)",
    fill: "#f8b067"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_293",
    "data-name": "Trazado 293",
    d: "M297.212,308.433c.089.015.161.086.249.093a.137.137,0,0,0,.152-.178c-.06-.151-.243-.186-.389-.189s-.165.249-.013.275h0Z",
    transform: "translate(-286.234 -300.94)",
    fill: "#f8b067"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_294",
    "data-name": "Trazado 294",
    d: "M271.664,296.282c.092.014.333.044.3.2a.152.152,0,0,0,.16.176.978.978,0,0,1,.5.231c.155.1.333-.129.23-.266a.763.763,0,0,0-.758-.263c.054.059.106.118.16.176.028-.365-.283-.46-.591-.452a.1.1,0,0,0-.01.2h0Z",
    transform: "translate(-263.455 -290.162)",
    fill: "#f8b067"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_295",
    "data-name": "Trazado 295",
    d: "M273.584,304.033a.44.44,0,0,1,.3.118.2.2,0,0,0,.252,0,.19.19,0,0,0,.033-.25.551.551,0,0,0-.643-.137.14.14,0,0,0,.058.272Z",
    transform: "translate(-265.109 -296.972)",
    fill: "#f8b067"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_296",
    "data-name": "Trazado 296",
    d: "M276.429,290.649a.533.533,0,0,1,.158.089.231.231,0,0,0,.088.049c.039,0,.042,0,.012,0a.091.091,0,0,0,.041.01.077.077,0,0,0,.088-.061.209.209,0,0,0,0-.063c0,.046,0-.039,0-.045a.276.276,0,0,0-.1-.113.476.476,0,0,0-.275-.075c-.128,0-.119.182-.01.21h0Z",
    transform: "translate(-267.706 -285.122)",
    fill: "#f8b067"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_297",
    "data-name": "Trazado 297",
    d: "M282.622,281.968a.309.309,0,0,1,.137.075c.025.021.043.048.068.069a.3.3,0,0,0,.113.049.14.14,0,0,0,.161-.112c.026-.249-.258-.362-.466-.36-.164,0-.163.244-.013.278Z",
    transform: "translate(-273.209 -277.311)",
    fill: "#f8b067"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_298",
    "data-name": "Trazado 298",
    d: "M254.443,272.838c.059-.009-.021-.011.023,0,.019,0,.038.012.057.016a.561.561,0,0,1,.092.026.306.306,0,0,1,.148.115.183.183,0,0,0,.323-.163.448.448,0,0,0-.352-.282.35.35,0,0,0-.36.158c-.038.052-.009.146.068.134h0Z",
    transform: "translate(-248.077 -269.143)",
    fill: "#f8b067"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_299",
    "data-name": "Trazado 299",
    d: "M261.645,269.319a.783.783,0,0,1,.282.289.163.163,0,0,0,.3-.1.452.452,0,0,0-.215-.341.4.4,0,0,0-.352-.046.111.111,0,0,0-.011.2Z",
    transform: "translate(-254.529 -266.068)",
    fill: "#f8b067"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_300",
    "data-name": "Trazado 300",
    d: "M249.036,267.02c.119-.039.146.071.162.158a.176.176,0,0,0,.3.1.271.271,0,0,1,.1-.05.121.121,0,0,0,.078-.121.076.076,0,0,0-.006-.03.121.121,0,0,0-.121-.078.327.327,0,0,1-.151-.005l.126.246a.4.4,0,0,0-.141-.468.407.407,0,0,0-.469.013.134.134,0,0,0,.119.236h0Z",
    transform: "translate(-243.17 -263.931)",
    fill: "#f8b067"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_301",
    "data-name": "Trazado 301",
    d: "M256.4,264.3a3.5,3.5,0,0,1,.435.132.156.156,0,0,0,.156-.239.541.541,0,0,0-.61-.121c-.105.036-.1.217.018.228h0Z",
    transform: "translate(-249.813 -261.548)",
    fill: "#f8b067"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_302",
    "data-name": "Trazado 302",
    d: "M268.234,283.546a.2.2,0,0,0-.065-.192.344.344,0,0,0-.166-.088c-.132-.031-.323,0-.35.158a.181.181,0,0,0,.1.186.518.518,0,0,0,.181.034.772.772,0,0,0,.157.011.192.192,0,0,0,.109-.056c-.014.018-.01.016.012-.005a.1.1,0,0,0,.023-.048h0Z",
    transform: "translate(-259.943 -278.708)",
    fill: "#f8b067"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_303",
    "data-name": "Trazado 303",
    d: "M267.169,293.151c.073,0,.125.107.138.166.028.117.1.193.228.165a.124.124,0,0,0,.082-.126.718.718,0,0,0-.059-.166.3.3,0,0,0-.113-.144.291.291,0,0,0-.306.017c-.046.025-.011.086.03.086h0Z",
    transform: "translate(-259.467 -287.417)",
    fill: "#f8b067"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_304",
    "data-name": "Trazado 304",
    d: "M259.807,301.561a.4.4,0,0,1,.341.2c.106.139.377.03.291-.146a.569.569,0,0,0-.651-.293c-.146.031-.14.252.019.239h0Z",
    transform: "translate(-252.831 -294.823)",
    fill: "#f8b067"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_305",
    "data-name": "Trazado 305",
    d: "M273.777,309.385a.884.884,0,0,0,.128.053.981.981,0,0,1,.12.05c.091.038.211-.07.137-.16a.363.363,0,0,0-.193-.118.233.233,0,0,0-.2.042.077.077,0,0,0,.01.132h0Z",
    transform: "translate(-265.375 -301.87)",
    fill: "#f8b067"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_306",
    "data-name": "Trazado 306",
    d: "M285.865,313.921a2.044,2.044,0,0,1,.192.14.14.14,0,0,0,.222-.15.3.3,0,0,0-.166-.188.286.286,0,0,0-.237,0,.111.111,0,0,0-.011.2h0Z",
    transform: "translate(-276.149 -305.881)",
    fill: "#f8b067"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_307",
    "data-name": "Trazado 307",
    d: "M294.7,317.116a3.012,3.012,0,0,1,.322.149.164.164,0,0,0,.178-.272,1.289,1.289,0,0,0-.35-.191.178.178,0,0,0-.232.082.175.175,0,0,0,.082.232Z",
    transform: "translate(-284.003 -308.643)",
    fill: "#f8b067"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_308",
    "data-name": "Trazado 308",
    d: "M328.014,328.349c.031,0,.05.023.082.035a.888.888,0,0,0,.13.033c.08.017.161.038.241.05a.162.162,0,0,0,.1-.3.49.49,0,0,0-.325-.061.417.417,0,0,0-.147.049c-.053.031-.065.076-.109.114a.046.046,0,0,0,.029.084h0Z",
    transform: "translate(-313.785 -318.739)",
    fill: "#f8b067"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_309",
    "data-name": "Trazado 309",
    d: "M334.982,328.483a.887.887,0,0,0,.353.2.147.147,0,0,0,.121-.253.89.89,0,0,0-.38-.147.114.114,0,0,0-.094.2Z",
    transform: "translate(-320.015 -318.904)",
    fill: "#f8b067"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_310",
    "data-name": "Trazado 310",
    d: "M229.166,275.623a.414.414,0,0,1,.212.031c.1.026.218-.02.208-.143s-.145-.167-.241-.188a.642.642,0,0,0-.282.01.156.156,0,0,0-.094.2.158.158,0,0,0,.2.094h0Z",
    transform: "translate(-225.406 -271.618)",
    fill: "#f8b067"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_311",
    "data-name": "Trazado 311",
    d: "M241.489,277.243c.063-.017.149.162.187.2a.67.67,0,0,0,.23.131,1.257,1.257,0,0,1,.26.117c.075.053.108.1.2.106a.094.094,0,0,0,.106-.074c.053-.277-.3-.335-.5-.372-.209-.041-.316-.351-.551-.231-.074.038-.01.143.062.122Z",
    transform: "translate(-236.505 -273.208)",
    fill: "#f8b067"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_312",
    "data-name": "Trazado 312",
    d: "M237.057,282.254c.105-.005.159.081.21.151a.324.324,0,0,0,.174.119.687.687,0,0,0,.538.026.125.125,0,0,0,.012-.2.371.371,0,0,0-.283-.089.472.472,0,0,1-.2-.026.44.44,0,0,1-.111-.093.287.287,0,0,0-.382-.006.063.063,0,0,0,.04.114Z",
    transform: "translate(-232.574 -277.651)",
    fill: "#f8b067"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_313",
    "data-name": "Trazado 313",
    d: "M232.284,286.2c.1,0,.179.046.273.044a.1.1,0,0,0,.072-.15.375.375,0,0,0-.383-.074c-.107.025-.062.184.039.18Z",
    transform: "translate(-228.283 -281.16)",
    fill: "#f8b067"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_314",
    "data-name": "Trazado 314",
    d: "M237.432,289.564c.3.055.453.452.786.412a.144.144,0,0,0,.049-.27,2.066,2.066,0,0,1-.259-.148,1.419,1.419,0,0,0-.21-.147.4.4,0,0,0-.4.013.078.078,0,0,0,.03.141Z",
    transform: "translate(-232.911 -284.161)",
    fill: "#f8b067"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_315",
    "data-name": "Trazado 315",
    d: "M241.111,268.584a1.527,1.527,0,0,0,.19.182.693.693,0,0,0,.246.113c.133.027.248-.174.123-.256a1.019,1.019,0,0,0-.226-.107c-.078-.028-.165-.04-.241-.069a.083.083,0,0,0-.09.137h0Z",
    transform: "translate(-236.229 -265.483)",
    fill: "#f8b067"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_316",
    "data-name": "Trazado 316",
    d: "M222.384,272.241c.057.136.222.327.386.3a.12.12,0,0,0,.1-.158c-.035-.163-.277-.24-.424-.241a.076.076,0,0,0-.065.1h0Z",
    transform: "translate(-219.53 -268.786)",
    fill: "#f8b067"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_317",
    "data-name": "Trazado 317",
    d: "M211.976,265.709a1.011,1.011,0,0,0,.244.335.512.512,0,0,0,.373.181.112.112,0,0,0,.094-.146c-.043-.124-.163-.188-.268-.256a2.126,2.126,0,0,0-.361-.187c-.042-.017-.105.023-.082.073h0Z",
    transform: "translate(-210.241 -262.977)",
    fill: "#f8b067"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_318",
    "data-name": "Trazado 318",
    d: "M204.472,255.633c.1.061.228.061.308.161s.109.206.233.253a.132.132,0,0,0,.132-.01c.149-.124-.055-.36-.152-.457-.135-.137-.392-.236-.547-.076a.083.083,0,0,0,.027.129Z",
    transform: "translate(-203.502 -253.862)",
    fill: "#f8b067"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_319",
    "data-name": "Trazado 319",
    d: "M195.857,248.162a.834.834,0,0,0,.25.142.879.879,0,0,1,.249.2c.134.158.4-.011.274-.185-.146-.2-.547-.47-.779-.252a.065.065,0,0,0,.006.09h0Z",
    transform: "translate(-195.835 -247.228)",
    fill: "#f8b067"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_320",
    "data-name": "Trazado 320",
    d: "M204.408,243.9a.271.271,0,0,1,.174.113.074.074,0,0,0,.118-.081.3.3,0,0,0-.287-.159.064.064,0,0,0-.006.127h0Z",
    transform: "translate(-203.442 -243.459)",
    fill: "#f8b067"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_321",
    "data-name": "Trazado 321",
    d: "M218.685,243.981a.339.339,0,0,1,.172.088.292.292,0,0,0,.146.082.045.045,0,0,0,.052-.035c.046-.179-.218-.25-.346-.257-.077,0-.1.109-.023.123h0Z",
    transform: "translate(-216.19 -243.54)",
    fill: "#f8b067"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_322",
    "data-name": "Trazado 322",
    d: "M228.8,244.247a.644.644,0,0,0,.322.178.134.134,0,0,0,.082-.252.641.641,0,0,0-.357-.069.082.082,0,0,0-.046.142h0Z",
    transform: "translate(-225.242 -243.759)",
    fill: "#f8b067"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_323",
    "data-name": "Trazado 323",
    d: "M230,241.028a.193.193,0,0,0,.1-.052.046.046,0,0,0-.015-.071.214.214,0,0,0-.119-.018c-.1,0-.077.171.03.141h0Z",
    transform: "translate(-226.249 -240.887)",
    fill: "#f8b067"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_324",
    "data-name": "Trazado 324",
    d: "M225.866,250.4a.369.369,0,0,0,.144.032.13.13,0,0,0,.1-.2.387.387,0,0,0-.116-.092c-.162-.094-.3.194-.126.262h0Z",
    transform: "translate(-222.569 -249.125)",
    fill: "#f8b067"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_325",
    "data-name": "Trazado 325",
    d: "M202.177,230.347a5.068,5.068,0,0,0-1.529-.587c-.3-.045-.61-.029-.912-.082a1.4,1.4,0,0,0-.821.036.489.489,0,0,0-.285.411c-.123.968.962,1.054,1.635,1,.654-.056,1.183.416,1.837.209a.57.57,0,0,0,.075-.984Z",
    transform: "translate(-185.774 -204.991)",
    fill: "#e74019"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_326",
    "data-name": "Trazado 326",
    d: "M230.541,264.445a3.227,3.227,0,0,0,1.1-.406c.193-.128.366-.3.561-.421a1.214,1.214,0,0,0,.468-.452.51.51,0,0,0,.026-.423c-.261-.709-.925-.2-1.3.187s-.835.338-1.147.817c-.187.287.014.754.294.7h0Z",
    transform: "translate(-213.942 -234.231)",
    fill: "#e74019"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_327",
    "data-name": "Trazado 327",
    d: "M309.483,299.665a3.243,3.243,0,0,0,.41-1.095c.029-.23.014-.472.048-.7a1.209,1.209,0,0,0-.036-.649.508.508,0,0,0-.3-.3c-.707-.266-.758.568-.707,1.105.048.522-.29.853-.131,1.4.094.328.581.483.719.232Z",
    transform: "translate(-284.06 -265.015)",
    fill: "#e74019"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_328",
    "data-name": "Trazado 328",
    d: "M367.724,307.455a3.511,3.511,0,0,0-.631-1.191c-.187-.216-.43-.416-.611-.633a1.846,1.846,0,0,0-.646-.539.9.9,0,0,0-.573-.074c-.94.194-.2.944.351,1.379.538.421.521.911,1.191,1.29.4.226,1.02.069.919-.231h0Z",
    transform: "translate(-334.132 -272.27)",
    fill: "#e74019"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_25",
    "data-name": "Grupo 25",
    transform: "translate(28.225 32.958)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_329",
    "data-name": "Trazado 329",
    d: "M342.976,307.707l-.742-.539c-.061-.044-.151-.088-.2-.034a.167.167,0,0,0-.034.112c-.005.116-.09,1.119-.062,1.568a.7.7,0,0,0,.063.287.5.5,0,0,0,.516.222,1.263,1.263,0,0,0,.535-.252.9.9,0,0,0,.45-.619.649.649,0,0,0-.165-.434,1.936,1.936,0,0,0-.358-.309Z",
    transform: "translate(-341.928 -307.11)",
    fill: "#2e2b37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_330",
    "data-name": "Trazado 330",
    d: "M342.351,307.429a.44.44,0,0,1,.219.024l.1.027-.428-.311c-.061-.044-.151-.088-.2-.034a.167.167,0,0,0-.034.112c0,.1-.062.791-.068,1.285a8.561,8.561,0,0,1,.2-.879.358.358,0,0,1,.221-.221Z",
    transform: "translate(-341.93 -307.11)",
    fill: "#46434e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_331",
    "data-name": "Trazado 331",
    d: "M342.5,317.084a.558.558,0,0,1-.4-.012.452.452,0,0,0,.568.391,1.253,1.253,0,0,0,.536-.253.9.9,0,0,0,.45-.619.6.6,0,0,0-.112-.361,1.6,1.6,0,0,1-.15.246,1.662,1.662,0,0,1-.894.608Z",
    transform: "translate(-342.082 -315.251)",
    fill: "#080810"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_332",
    "data-name": "Trazado 332",
    d: "M345.126,312.1a.186.186,0,0,0-.068-.023.141.141,0,0,0-.244.028c-.113.224-.029.747.3.73.4-.021.261-.6.016-.734Zm-.151.446.005-.008s0,0,0,0,0,.012-.008,0Z",
    transform: "translate(-344.463 -311.491)",
    fill: "#ef7d25"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_26",
    "data-name": "Grupo 26",
    transform: "translate(20.377 30.76)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_333",
    "data-name": "Trazado 333",
    d: "M270.546,287.755c.027-.3.054-.608.082-.913.006-.075,0-.175-.075-.193a.165.165,0,0,0-.113.028c-.1.055-1.007.5-1.377.752a.686.686,0,0,0-.214.2.505.505,0,0,0,.075.557,1.243,1.243,0,0,0,.493.329.894.894,0,0,0,.762.068.639.639,0,0,0,.286-.365,1.9,1.9,0,0,0,.081-.467Z",
    transform: "translate(-268.795 -286.645)",
    fill: "#2e2b37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_334",
    "data-name": "Trazado 334",
    d: "M274.689,287.065a.444.444,0,0,1,.092.2l.026.1c.016-.176.031-.352.047-.528.006-.075,0-.175-.075-.193a.165.165,0,0,0-.113.028c-.085.045-.71.353-1.136.6a8.309,8.309,0,0,1,.856-.281.362.362,0,0,1,.3.076Z",
    transform: "translate(-273.022 -286.636)",
    fill: "#46434e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_335",
    "data-name": "Trazado 335",
    d: "M269.162,294.958a.555.555,0,0,1-.194-.348.492.492,0,0,0-.118.131.505.505,0,0,0,.075.557,1.243,1.243,0,0,0,.493.329.894.894,0,0,0,.762.068.607.607,0,0,0,.252-.281,1.611,1.611,0,0,1-.288,0,1.67,1.67,0,0,1-.982-.454Z",
    transform: "translate(-268.795 -293.754)",
    fill: "#080810"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_336",
    "data-name": "Trazado 336",
    d: "M277.51,291.74a.2.2,0,0,0-.015-.07.14.14,0,0,0-.149-.194c-.251.018-.655.36-.473.629.223.332.647-.084.637-.364Zm-.461.1h.01s0,0,0,0-.01.008-.006,0Z",
    transform: "translate(-275.965 -290.956)",
    fill: "#ef7d25"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_27",
    "data-name": "Grupo 27",
    transform: "translate(14.626 26.895)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_337",
    "data-name": "Trazado 337",
    d: "M216.631,251.975l.73-.554c.06-.046.128-.119.092-.186a.158.158,0,0,0-.1-.064c-.109-.039-1.045-.41-1.483-.512a.68.68,0,0,0-.293-.021.5.5,0,0,0-.362.43,1.267,1.267,0,0,0,.087.586.9.9,0,0,0,.462.61.641.641,0,0,0,.463-.033,1.922,1.922,0,0,0,.4-.254Z",
    transform: "translate(-215.21 -250.628)",
    fill: "#2e2b37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_338",
    "data-name": "Trazado 338",
    d: "M224.871,252.349a.441.441,0,0,1-.086.2l-.054.084.422-.32c.06-.046.128-.119.092-.186a.158.158,0,0,0-.1-.064c-.09-.032-.739-.289-1.209-.436a8.494,8.494,0,0,1,.784.444.359.359,0,0,1,.147.276Z",
    transform: "translate(-223.003 -251.521)",
    fill: "#46434e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_339",
    "data-name": "Trazado 339",
    d: "M215.64,251a.554.554,0,0,1,.127-.378.51.51,0,0,0-.176,0,.5.5,0,0,0-.362.43,1.267,1.267,0,0,0,.087.586.9.9,0,0,0,.463.61.611.611,0,0,0,.377,0,1.576,1.576,0,0,1-.191-.215A1.664,1.664,0,0,1,215.64,251Z",
    transform: "translate(-215.219 -250.618)",
    fill: "#080810"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_340",
    "data-name": "Trazado 340",
    d: "M223.512,255.991a.22.22,0,0,0,.042-.059.141.141,0,0,0,.044-.241c-.182-.173-.706-.243-.783.073-.1.387.5.423.7.228Zm-.384-.274.006.008h0c-.011,0-.012,0,0-.008Z",
    transform: "translate(-221.989 -255.015)",
    fill: "#ef7d25"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.778993d77aef1f3da36a7bf2994e1219.svg";
export { ForwardRef as ReactComponent };